import { pubsub } from '@services';
import { getCurrentComparisonData, makeNewComparisonData, processNewComparisonData } from '@utils';

class CompareDrawer extends HTMLElement {
  connectedCallback() {
    this.compareItemsList = this.querySelector('[data-compare-items-list]');
    this.noItemsMessage = this.querySelector('[data-no-items-message]');
    this.template = this.querySelector('template');
    this.compareCurrentAmountInButton = this.querySelector('[data-current-amount]');
    if (
      !this.compareItemsList ||
      !this.noItemsMessage ||
      !this.template ||
      !this.compareCurrentAmountInButton
    )
      return;

    this.items = getCurrentComparisonData();

    this.renderItems();
    this.updateCompareButton();
    this.unsubScribeToComparisonUpdate = pubsub.subscribe('comparison:update', (payload) =>
      this.handleUpdate(payload)
    );
  }

  disconnectedCallback() {
    if (!this.unsubScribeToComparisonUpdate) return;
    this.unsubScribeToComparisonUpdate();
  }

  handleUpdate(payload) {
    if (payload.id === 'compare-drawer') return;
    this.items = payload.newComparisonItems;
    this.renderItems();
    this.updateCompareButton();
  }

  handleRemoveItem(index) {
    const newData = makeNewComparisonData(this.items, false, index, this.items[index]);
    processNewComparisonData(newData, 'compare-drawer');
    this.items = newData;
    this.renderItems();
    this.updateCompareButton();
  }

  renderItems() {
    if (this.items.length === 0) {
      this.noItemsMessage.classList.remove('hidden');
      this.compareItemsList.classList.add('hidden');
    } else {
      this.noItemsMessage.classList.add('hidden');
      this.compareItemsList.classList.remove('hidden');

      this.compareItemsList.innerHTML = '';
      this.items.forEach((item, index) => {
        const clone = this.template.content.cloneNode(true);
        const cloneTitle = clone.querySelector('[data-title]');
        const cloneVariationId = clone.querySelector('[data-variation-id]');
        const clonePrice = clone.querySelector('[data-price]');
        const cloneImage = clone.querySelector('img');

        cloneTitle.textContent = item.title;
        cloneVariationId.textContent = item.id;
        clonePrice.textContent = item.price;
        cloneImage.src = item.productImage;
        cloneImage.alt = item.title;

        clone.querySelector('button').addEventListener('click', () => this.handleRemoveItem(index));
        this.compareItemsList.appendChild(clone);
      });
    }
  }

  updateCompareButton() {
    this.compareCurrentAmountInButton.textContent = `${this.items.length}`;
  }
}

customElements.define('compare-drawer', CompareDrawer);
